import React from 'react';
import { motion } from 'framer-motion';
export function TruthBomb() {
  return <section className="w-full bg-navy text-cream py-20 px-6 my-12" data-id="element-160">
      <div className="max-w-3xl mx-auto text-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-162">
          <span className="text-teal font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-163">
            La verdad incómoda
          </span>

          <h2 className="text-4xl md:text-6xl font-serif font-bold mb-8 leading-tight" data-id="element-164">
            Tu problema no es falta de creatividad.
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-12" data-id="element-165">
            Tu problema es que estás tomando{' '}
            <span className="text-white font-bold border-b-2 border-teal" data-id="element-166">
              demasiadas decisiones desde cero
            </span>
            , cada semana.
          </p>

          <p className="text-lg md:text-xl text-cream/80 italic" data-id="element-167">
            Y las plantillas vacías no arreglan eso. <br data-id="element-168" />
            Solo te dan un lugar donde escribir tu cansancio.
          </p>
        </motion.div>
      </div>
    </section>;
}